import React from "react";

export const Message = ({ message }) => {
  const isUser = message.sender === "user";
  const animationDelay = `${(message.id % 10) * 0.05}s`;

  return (
    <div
      data-testid={`message-${message.id}`}
      className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-3`}
      style={{
        animation: `${isUser ? 'slideInRight' : 'slideInLeft'} 0.55s cubic-bezier(0.22, 1, 0.36, 1) both`,
        animationDelay,
        filter: 'drop-shadow(0 14px 28px rgba(0,0,0,0.18))',
      }}
    >
      <div
        className={`max-w-[78%] px-4 py-2.5 ${
          isUser ? 'rounded-2xl rounded-br-md' : 'rounded-2xl rounded-bl-md'
        }`}
        style={{
          background: isUser
            ? 'linear-gradient(180deg, rgba(44,36,29,0.92) 0%, rgba(36,28,23,0.9) 100%)'
            : 'transparent',
          color: isUser ? '#C8B8A5' : '#F1E4D3',
          border: isUser ? '1px solid rgba(255,255,255,0.04)' : 'none',
          boxShadow: isUser
            ? '0 18px 38px rgba(0,0,0,0.2)'
            : 'none',
          transform: 'translateZ(0)',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          padding: isUser ? '14px 16px' : '4px 2px',
        }}
      >
        {!isUser && (
          <p className="mb-3 text-[10px] uppercase tracking-[0.34em]" style={{ color: '#A67A2E' }}>
            Emily 2.0
          </p>
        )}
        <p className="text-sm leading-[2rem]">{message.text}</p>
        <p
          className="text-[10px] mt-1"
          style={{ color: isUser ? 'rgba(200,184,165,0.45)' : 'rgba(255,244,230,0.26)' }}
        >
          {message.time}
        </p>
      </div>
    </div>
  );
};

export default Message;
